/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon32Regular = forwardRef('ShapeTriangleUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.612 5.019c1.568-2.5 5.208-2.5 6.776 0l10.576 16.855C31.636 24.538 29.721 28 26.576 28H5.424c-3.145 0-5.06-3.462-3.388-6.126L12.612 5.02Zm5.082 1.063a2 2 0 0 0-3.388 0L3.73 22.937C2.894 24.27 3.85 26 5.424 26h21.152c1.572 0 2.53-1.731 1.694-3.063L17.694 6.082Z" })));
});
